module.exports = __webpack_public_path__ + "assets/img/8_1759_big.64c61853.jpg";